import type { IMasterDataProductCategoryRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataProductCategoriesDTO } from "@src/domain/dto/masterData";

export class GetMasterDataProductCategoriesUseCase {
  private readonly repository: IMasterDataProductCategoryRepository;

  constructor(repository: IMasterDataProductCategoryRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataProductCategoriesDTO) {
    return this.repository.getProductCategories(params);
  }
}
